import * as actions from "../actions/Type";
const intialState = {
  creating_invoice: {},
  creating_invoice_rent: {},
  sell_contracts: [],
  rent_contracts: [],
  all_rent_contracts_failed: [],
  sell_invoice_obj: {},
  rent_invoice_obj: {},
  tanents_list: [],
  new_takemoney: {},
  list_of_take_money: [],
  list_of_each_tenant: [],
  take_money_view: {},
  view_each_recontract: {},
  recontract_invoice: {},
  list_of_each_take_money: [],
  List_names: [],
  list_bills: [],
  list_paradan: [],
  list_scurety: [],
  index_all_takemoney: "",
  index_all_paradan: "",
  all__bill: [],
  view_bills: {},
  //rent
  all_rent_contracts: [],
  rent_all_view_obj: {},
  index_all_rent: "",
  //sell
  all_sell_contracts: [],
  all_sell_contracts_failed: [],
  sell_all_view_obj: {},
  index_all_sell: "",
  // project bills
  list_project_bills: [],
  project_view_bills: {},
  // vellas contract
  vella_contracts: [],
  view_vella_contract: {},
  View_just_vella_obj: {},
  branchId: {},
  /// tenant
  tenant_view_takemoney_arr: [],
  tenant_view_paradan_arr: [],
  tenant_view_contracts_arr: [],
  id_tenant: "",
  id_tenant_paradan: "",
  // writer
  list_writer: [],
  view_writer: {},
  //array delete list bills
  all_sell_delete_contracts: [],
  all_rent_delete_contracts: [],
  all_takemoney_delete_bill: [],
  all_paradan_delete_bill: [],
  all_tenant_delete_contracts: [],
  // loadin
  S_status: false,
  S_status_failed: false,
  R_status_failed: false,
  R_status: false,
  takemoney_status: false,
  paradan_status: false,
  scurety_status: false,
  tenant_status: false,
  R_delete_status: false,
  S_delete_status: false,
  T_delete_status: false,
  P_delete_status: false,
  S_project_status: false,
  all_bill__status: false,
  tenant_delete_status: false,
};
const InvoiceReducer = (state = intialState, action) => {
  switch (action.type) {
    case actions.GET_SELL_CONTRACTS:
      return {
        ...state,
        sell_contracts: action.payload,
      };
    case actions.VIEW_CONTRACT_SELL:
      return {
        ...state,
        sell_invoice_obj: action.payload,
      };

    case actions.GET_RENT_CONTRACTS:
      return {
        ...state,
        rent_contracts: action.payload,
      };
    case actions.VIEW_CONTRACT_RENT:
      return {
        ...state,
        rent_invoice_obj: action.payload,
      };

    case actions.GET_LIST_OF_TANENTS:
      return {
        ...state,
        tanents_list: action.payload,
        tenant_status: action.tenant_status,
      };

    case actions.TAKE_MONEY_VIEW:
      return {
        ...state,
        take_money_view: action.payload,
      };

    case actions.VIEW_RECONTRACT:
      return {
        ...state,
        view_each_recontract: action.payload,
      };

    case actions.GET_EACH_TENANT_LIST:
      return {
        ...state,
        list_of_each_tenant: action.payload,
      };

    case actions.TAKE_EACH_MONEY_LIST:
      return {
        ...state,
        list_of_each_take_money: action.payload,
      };
    case actions.GET_LIST_BILLS:
      return {
        ...state,
        list_bills: action.payload,
        takemoney_status: action.takemoney_status,
      };
    case actions.GET_LIST_PARADAN:
      return {
        ...state,
        list_paradan: action.payload,
        paradan_status: action.paradan_status,
      };
    case actions.GET_LIST_ASAYESH:
      return {
        ...state,
        list_scurety: action.payload,
        scurety_status: action.scurety_status,
      };
    case actions.SCURETY_VIEW:
      return {
        ...state,
        scurety_view: action.payload,
      };
    case actions.PARADAN_VIEW:
      return {
        ...state,
        paradan_view: action.payload,
        index_all_paradan: action.index_all_paradan,
      };
    case actions.VIEW_TAKE_MONEY:
      return {
        ...state,
        parawargrtn_view: action.payload,
        index_all_takemoney: action.index_all_takemoney,
      };
    case actions.GET_ALL_SELL_CONTRACTS:
      return {
        ...state,
        all_sell_contracts: action.payload.doc,
        S_status: action.S_status,
      };
    case actions.GET_ALL_SELL_CONTRACTS_FAILED:
      return {
        ...state,
        all_sell_contracts_failed: action.payload.doc,
        S_status_failed: action.S_status_failed,
      };
    case actions.GET_ALL_RENT_CONTRACTS:
      return {
        ...state,
        all_rent_contracts: action.payload.doc,
        R_status: action.R_status,
      };
    case actions.GET_ALL_RENT_CONTRACTS_FAILED:
      return {
        ...state,
        all_rent_contracts_failed: action.payload.doc,
        R_status_failed: action.R_status_failed,
      };
    case actions.VIEW_ALL_CONTRACT_SELL:
      return {
        ...state,
        sell_all_view_obj: action.payload,
        index_all_sell: action.index_all_sell,
      };
    case actions.VIEW_ALL_CONTRACT_RENT:
      return {
        ...state,
        rent_all_view_obj: action.payload,
        index_all_rent: action.index_all_rent,
      };
    case actions.DELETE_SELL:
      return {
        ...state,
        all_sell_contracts: state.all_sell_contracts.filter(
          (el) => el._id !== action.sell_id
        ),
        all_sell_delete_contracts: state.all_sell_delete_contracts.filter(
          (el) => el._id !== action.sell_id
        ),
        all_sell_contracts_failed: state.all_sell_contracts_failed.filter(
          (el) => el._id !== action.sell_id
        ),
      };
    case actions.DELETE_RENT:
      return {
        ...state,
        all_rent_contracts: state.all_rent_contracts.filter(
          (el) => el._id !== action.rent_id
        ),
        all_rent_delete_contracts: state.all_rent_delete_contracts.filter(
          (el) => el._id !== action.rent_id
        ),
      };
    case actions.DELETE_TAKEMONEY:
      return {
        ...state,
        list_bills: state.list_bills.filter((el) => el._id !== action.id),
        all_takemoney_delete_bill: state.all_takemoney_delete_bill.filter(
          (el) => el._id !== action.id
        ),
      };
    case actions.DELETE_PARADAN:
      return {
        ...state,
        list_paradan: state.list_paradan.filter((el) => el._id !== action.id),
        all_paradan_delete_bill: state.all_paradan_delete_bill.filter(
          (el) => el._id !== action.id
        ),
      };
    case actions.UPDATE_PARADAN:
      return {
        ...state,
      };
    case actions.UPDATE_TAKEMONEY:
      return {
        ...state,
      };
    case actions.UPDATE_SELL_CONTRACT:
      return {
        ...state,
      };
    case actions.UPDATE_RENT_CONTRACT:
      return {
        ...state,
      };
    case actions.DELETE_TENANTS:
      return {
        ...state,
      };
    case actions.GET_PROJECT_BILLS:
      return {
        ...state,
        list_project_bills: action.payload,
        S_project_status: action.S_project_status,
      };
    case actions.VIEW_PROJECT_BILLS:
      return {
        ...state,
        project_view_bills: action.payload,
        index: action.obj,
      };
    case actions.GET_VELLA_CONTRACTS:
      return {
        ...state,
        vella_contracts: action.payload,
      };
    case actions.VIEW_CONTRACT_VELLA:
      return {
        view_vella_contract: action.payload,
        View_just_vella_obj: action.payload.ViellaId,
        branchId: action.payload.branchId,
        vella_contracts: [],
      };
    case actions.VIEW_TENANT_TAKYMONEY:
      return {
        ...state,
        tenant_view_takemoney_arr: action.payload,
        id_tenant: action.id_tenant,
        tenant_view_paradan_arr: [],
        tenant_view_contracts_arr: [],
      };
    case actions.VIEW_TENANT_PARADAN:
      return {
        ...state,
        tenant_view_paradan_arr: action.payload,
        id_tenant_paradan: action.id_tenant_paradan,
        tenant_view_takemoney_arr: [],
        tenant_view_contracts_arr: [],
      };
    case actions.VIEW_TENANT_CONTRACTS:
      return {
        ...state,
        tenant_view_contracts_arr: action.payload,
        tenant_view_takemoney_arr: [],
        tenant_view_paradan_arr: [],
      };
    case actions.GET_WRITERS_LIST:
      return {
        ...state,
        list_writer: action.payload,
      };
    case actions.VIEW_WRITORS:
      return {
        ...state,
        view_writer: action.payload,
      };
    case actions.DELETE_WRITER:
      return {
        ...state,
      };
    case actions.WRITER_UPDATE:
      return {
        ...state,
      };
    case actions.SCURETY_DELETE:
      return {
        ...state,
      };
    case actions.SCURITY_UPDATE:
      return {
        ...state,
      };
    case actions.GET_ALL_SELL_CONTRACTS_DELETE:
      return {
        ...state,
        all_sell_delete_contracts: action.payload,
        S_delete_status: action.S_delete_status,
      };
    case actions.GET_ALL_RENT_CONTRACTS_DELETE:
      return {
        ...state,
        all_rent_delete_contracts: action.payload,
        R_delete_status: action.R_delete_status,
      };
    case actions.GET_ALL_TENANTS_CONTRACTS_DELETE:
      return {
        ...state,
        all_tenant_delete_contracts: action.payload,
        tenant_delete_status: action.tenant_delete_status,
      };
    case actions.GET_ALL_TAKEMONEY_DELETE:
      return {
        ...state,
        all_takemoney_delete_bill: action.payload,
        T_delete_status: action.T_delete_status,
      };
    case actions.GET_ALL_PARADAN_DELETE:
      return {
        ...state,
        all_paradan_delete_bill: action.payload,
        P_delete_status: action.P_delete_status,
      };
    case actions.ACTIVATE_TENANT:
      return {
        ...state,
      };
    // all bills
    // case actions.GET_LIST_BILLS_ALL:
    //   return {
    //     ...state,
    //     all__bill: action.payload,
    //     all_bill__status: action.all_bill__status,
    //   };
    // case actions.VIEW_ALL_BILLS:
    //   return {
    //     ...state,
    //     view_bills: action.payload,
    //   };
    // case actions.DELETE_BILL:
    //   return {
    //     ...state,
    //     all__bill: state.all__bill.filter((el) => el._id !== action.id),
    //   };
    // case actions.UPDATE_ALL_BILLS:
    //   return {
    //     ...state,
    //   };
    default:
      return { ...state };
  }
};

export default InvoiceReducer;
